import CalendarService from '../lib/services/CalendarService';

const fetchMA = (params = {}, pageSize = 1000): Promise<any> => {
  const query = {
    ...params,
    pagesize: pageSize,
  };

  const Calendar = new CalendarService();

  return Calendar.getMA(query).then(({ data }: any) => {
    if (data && data.ma) {
      return data.ma;
    }

    return [];
  });
};

export { fetchMA };
